<template>
  <div>
    <a-row type="flex" justify="end" class="mb-5">
      <a-space>
        <a-popconfirm title="Are you sure you want to create disbursement biller amount" @confirm="createDisbursement('biller_amount')">
          <a-button type="default" icon="plus">Biller Amount</a-button>
        </a-popconfirm>

        <a-popconfirm title="Are you sure you want to create disbursement profit" @confirm="createDisbursement('profit')">
          <a-button type="default" icon="plus">Bank Fee</a-button>
        </a-popconfirm>

        <a-popconfirm title="Are you sure you want to create disbursement biller profit" @confirm="createDisbursement('biller_profit')">
          <a-button type="default" icon="plus">Biller Fee</a-button>
        </a-popconfirm>

        <a-popconfirm title="Are you sure you want to create disbursement sponsor profit" @confirm="createDisbursement('sponsor_profit')">
          <a-button type="default" icon="plus">Sponsor Fee</a-button>
        </a-popconfirm>
      </a-space>
    </a-row>
    <a-card size="small" type="inner" title="Transaction Disbursement">
      <div slot="extra">
        <a-button size="small" icon="filter" title="Filter Form" @click="() => drawerStatus.filtering = true" />
      </div>

      <a-skeleton :loading="loading" active>
        <a-table :columns="columns" :dataSource="items.data" :rowKey="(record) => record.id">

          <h5 slot="reconcile_date" slot-scope="record" class="text-center">
            {{ moment(record.reconcile_start_date).format('DD/MM/YYYY') }} - {{ moment(record.reconcile_end_date).format('DD/MM/YYYY') }}
          </h5>

          <h5 slot="datetime" slot-scope="datetime" class="text-center">
            {{ moment(datetime).format('DD/MM/YYYY HH:mm:ss') }}
          </h5>

          <h5 slot="updated_at" slot-scope="updated_at" class="text-center">
            {{ moment(updated_at).format('DD/MM/YYYY HH:mm:ss') }}
          </h5>

          <h5 slot="type" slot-scope="type" class="text-center">
            {{ type.toUpperCase() }}
          </h5>

          <div slot="disbursementable" slot-scope="record">
            <h4>
              <a-icon type="gateway" /> <small><code>{{ record.biller ? record.biller.name : record.sponsor ? record.sponsor.sponsor_name : '-' }}</code></small>
            </h4>
          </div>

          <h5 slot="account" slot-scope="record">
            <code>Source: {{ record.source_account_number }}</code>
            <br>
            <code>Destination: {{ record.destination_account_number }}</code>
          </h5>

          <h4 slot="amount" slot-scope="amount" class="text-center">
            <currency :amount="amount" />
          </h4>

          <h5 slot="remark" slot-scope="record">
            <a-icon type="snippets" /> {{ record.remark_1 }}
            <br>
            <a-icon type="snippets" /> {{ record.remark_2 }}
            <br>
            <a-icon type="snippets" /> {{ record.remark_3 }}
            <br>
          </h5>

          <h5 slot="ref_number" slot-scope="ref_number" class="text-center">
            {{ ref_number }}
          </h5>

          <h5 slot="response_code" slot-scope="response_code" class="text-center">
            {{ response_code }}
          </h5>

          <div slot="status" slot-scope="status" class="text-center">
            <small><a-tag :color="statusColors[status]">{{ status.toUpperCase() }}</a-tag></small>
          </div>

          <div slot="action" slot-scope="record" class="text-center">
            <template v-if="record.status === 'pending' && !record.ref_number">
              <a-button-group size="small">
                <a-popconfirm title="Are you sure you want to disbursement this biller？" @confirm="approveOrRejectDisbursement(record.id, 'approve')">
                  <a-button icon="check" type="primary" :loading="processing.includes(record.id)"></a-button>
                </a-popconfirm>
                &nbsp;
                <a-popconfirm title="Are you sure you want to reject this disbursement" @confirm="approveOrRejectDisbursement(record.id, 'reject')">
                  <a-button icon="close" type="danger" :loading="processing.includes(record.id)"></a-button>
                </a-popconfirm>
              </a-button-group>
            </template>
          </div>
        </a-table>
      </a-skeleton>
    </a-card>

    <a-drawer :width="720" placement="right" :closable="true" :visible="drawerVisible" @close="closeDrawer">
      <template v-if="drawerStatus.filtering">
        <h-transaction-disbursement-filter v-if="showFilter" :filters="filters" :excludes="excludes" @filtered="filtered" />
      </template>
    </a-drawer>
  </div>
</template>

<script>
import {disbursement as columns} from '../../../tables'
import { serviceColors, statusColors } from '../../../config/deposit-request'
export default {
  props: {
    showFilter: {
      type: Boolean,
      default: true
    },
    excludes: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({
        q: null,
        page: 1,
        per_page: 10,
        date: [],
        status: [],
        billers: [],
        service: [],
        clients: [],
        products: [],
      })
    },
  },
  data() {
    return {
      columns,
      status,
      processing: [],
      loading: false,
      items: {},
      drawerStatus: {
        filtering: false
      },
    }
  },
  computed: {
    statusColors,
    drawerVisible() {
      return this.drawerStatus.filtering
    },
  },
  created() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true

      this.$http.get(this.routeUri('hyperion.transaction.disbursement'), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    approveOrRejectDisbursement(key, action) {
      let index = _.findIndex(this.items.data, {id: key})

      if (index >= 0) {
        this.sendDisbursement(this.items.data[index], action)
      }
    },
    sendDisbursement(param, action) {
      this.processing.push(param.id)

      this.$http.post(this.routeUri('hyperion.transaction.send.disbursement', { disbursement_id: param.id}), {action: action})
        .then((response) => this.handleActionSuccess(response.data))
        .catch((error) => this.handleXhrError(error))
        .finally(() => _.pull(this.processing, param.id))
    },
    handleActionSuccess(data) {
      this.$notification.success({
        message: "Success",
        description: "Disbursement has been processed!.",
        onClose: () => window.location.reload()
      })
    },
    createDisbursement(type) {
      window.location = this.routeUri('hyperion.transaction.disbursement.create') + '?' + this.$qs.stringify({type: type})
    },
    refresh() {
      this.$emit('filtered', this.filters)
      this.getItems()
    },
    closeDrawer() {
      this.drawerStatus.filtering = false
      this.editing = null
    },
    filtered(filters) {
      Object.assign(this.filters, filters)
      // this.drawerStatus.filtering = false
      this.pushState(this.filters)

      this.$emit('filtered', this.filters)
      this.getItems()
    },
  }
}
</script>
